import { FC } from 'react';

import { type ISourceOptions } from '@tsparticles/engine';
import { LazyParticles } from '../lazy-particles';
import { IParticlesProps } from '@tsparticles/react';
export const ExplosiveCofettie: FC<
  Partial<Omit<IParticlesProps, 'options'>>
> = ({ className }) => {
  return <LazyParticles className={className} options={options} />;
};

const options: ISourceOptions = {
  fullScreen: {
    enable: false,
  },
  particles: {
    number: {
      value: 0,
    },
    color: {
      value: ['#00FFFC', '#FC00FF', '#fffc00', '#FF0000', '#00FF00'],
    },
    shape: {
      type: 'square',
      options: {},
    },
    opacity: {
      value: {
        min: 0,
        max: 1,
      },
      animation: {
        enable: true,
        speed: 2,
        startValue: 'max',
        destroy: 'min',
      },
    },
    size: {
      value: {
        min: 3,
        max: 6,
      },
    },
    links: {
      enable: false,
    },
    life: {
      duration: {
        sync: true,
        value: 5,
      },
      count: 1,
    },
    move: {
      enable: true,
      gravity: {
        enable: true,
        acceleration: 10,
      },
      speed: {
        min: 10,
        max: 20,
      },
      decay: 0.1,
      direction: 'none',
      straight: false,
      outModes: {
        default: 'destroy',
        top: 'none',
      },
    },
    rotate: {
      value: {
        min: 0,
        max: 360,
      },
      direction: 'random',
      move: true,
      animation: {
        enable: true,
        speed: 60,
      },
    },
    tilt: {
      direction: 'random',
      enable: true,
      move: true,
      value: {
        min: 0,
        max: 360,
      },
      animation: {
        enable: true,
        speed: 60,
      },
    },
    roll: {
      darken: {
        enable: true,
        value: 25,
      },
      enable: true,
      speed: {
        min: 15,
        max: 25,
      },
    },
    wobble: {
      distance: 30,
      enable: true,
      move: true,
      speed: {
        min: -15,
        max: 15,
      },
    },
  },
  emitters: {
    life: {
      count: 1,
      duration: 0.1,
      delay: 0.4,
    },
    rate: {
      delay: 0.1,
      quantity: 150,
    },
    size: {
      width: 0,
      height: 0,
    },
    position: {
      x: 50,
      y: 50,
    },
  },
};
